import React, { createContext, useContext, useEffect, useState } from "react";
import ApiClient from "../../helpers/ApiClient";
import { useLocalStorage } from "../../helpers/useStorage";

const CurrencyContext = createContext();

export function useCurrencyContext() {
  return useContext(CurrencyContext);
}

const CurrencyProvider = ({ children }) => {
  const [activeCurrency, setActiveCurrency] = useLocalStorage(
    "currency",
    "INR"
  );

  const [currencies, setCurrencies] = useState({ INR: 1 });
  useEffect(() => {
    ApiClient.get("admin/currencyConversionLatest")
      .then((resp) => {
        if (resp?.status == 200) {
          setCurrencies(resp.data);
        } else {
          // if (window.location.search !== "?error=Currency%20Error")
          //   window.location.href = "/error?error=Currency Error";
        }
      })
      .catch((e) => {
        // if (window.location.search !== "?error=Currency%20Error")
        //   window.location.href = "/error?error=Currency Error";
      });
  }, []);

  const getCurrencyValue = (amount) => {
    // Safety check: if currency is not available, return original amount in INR
    if (!currencies || !currencies[activeCurrency]) {
      console.warn(`Currency ${activeCurrency} not found in conversion rates. Using INR.`);
      return Number(parseFloat(amount).toFixed(2));
    }
    
    let currentUrl = window.location.href;
    let containsActivities = currentUrl?.includes("/activities");
    let buildyourpackage=currentUrl?.includes("/buildyourpackage");
    if(activeCurrency!=="INR" && (containsActivities || buildyourpackage)){
      const currencyRate = parseFloat(currencies[activeCurrency]) || 1;
      const baseAmount = parseFloat(currencies["INRBaseAmount"]) || 0;
      const rate = parseFloat((currencyRate + baseAmount).toFixed(2));
      if (isNaN(rate) || rate === 0) {
        return Number(parseFloat(amount).toFixed(2));
      }
      return Number(
        (parseInt(Math.ceil(amount)) / rate).toFixed(2)
      );  // --Code Changes by Karthik 27/April/2023
    }else{
      const currencyRate = parseFloat(currencies[activeCurrency]) || 1;
      const rate = parseFloat(currencyRate.toFixed(2));
      if (isNaN(rate) || rate === 0) {
        return Number(parseFloat(amount).toFixed(2));
      }
      return Number(
        (parseInt(Math.ceil(amount)) / rate).toFixed(2)
      ); 
    }
  }

  return (
    <CurrencyContext.Provider
      value={{
        activeCurrency: activeCurrency,
        currencyValue: (a) => getCurrencyValue(a),
        setActiveCurrency: (a) => setActiveCurrency(a),
      }}
    >
      {children}
    </CurrencyContext.Provider>
  );
};

export default CurrencyProvider;
